import { skipToken } from "@reduxjs/toolkit/query";
import { styled } from "styled-components";

import { useGetTopicQuery } from "api/topicsApi.slice";
import { ListItemBox } from "common/components";
import type { EditListItemProps } from "domains/topic/components/EditListItem";
import { EditListItem } from "domains/topic/components/EditListItem";

type KeyIssueTileProps = Omit<EditListItemProps, "subtitle"> & { parent_topic_id?: string };

const StyledListItemBox = styled(ListItemBox)`
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const KeyIssueTile = ({ image_url, parent_topic_id, ...props }: KeyIssueTileProps) => {
  const arg = parent_topic_id === undefined ? skipToken : { id: parent_topic_id };
  const getTopicQuery = useGetTopicQuery(arg);

  return (
    <StyledListItemBox>
      <EditListItem
        {...props}
        image_url={image_url ?? getTopicQuery.data?.images?.x_small}
        subtitle={getTopicQuery.data?.name}
      />
    </StyledListItemBox>
  );
};
